import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    // First item is open by default
  }

  toggle(event) {
    const button = event.currentTarget
    const item = button.closest("[data-faq-target='item']")
    const answer = item.querySelector(".faq-answer")
    const plusIcon = item.querySelector(".faq-icon-plus")
    const minusIcon = item.querySelector(".faq-icon-minus")

    const isOpen = answer.classList.contains("open")

    // Close all other items
    this.itemTargets.forEach((otherItem) => {
      if (otherItem !== item) {
        const otherAnswer = otherItem.querySelector(".faq-answer")
        const otherPlus = otherItem.querySelector(".faq-icon-plus")
        const otherMinus = otherItem.querySelector(".faq-icon-minus")

        otherAnswer.classList.remove("open")
        if (otherPlus) otherPlus.classList.remove("hidden")
        if (otherMinus) otherMinus.classList.add("hidden")
      }
    })

    // Toggle current item
    if (isOpen) {
      answer.classList.remove("open")
      if (plusIcon) plusIcon.classList.remove("hidden")
      if (minusIcon) minusIcon.classList.add("hidden")
    } else {
      answer.classList.add("open")
      if (plusIcon) plusIcon.classList.add("hidden")
      if (minusIcon) minusIcon.classList.remove("hidden")
    }
  }
}
